module.exports = __webpack_public_path__ + "img/shirt-fill.5d159fd1.svg";